import React, { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Modal, ModalBody, ModalHeader, Container, Col, Row, FormGroup, Label, Button, Input } from 'reactstrap'
import configData from "../../../../config.json";
import axios, { AxiosRequestConfig } from 'axios'
import { DatosVistaPrevia } from '../AnalistaAdministraSolicitudesCertificados';
import IconCloseModal from 'components/Varios/Modals/IconCloseModal';
import Cargando from 'components/Varios/Cargando';
import InputFileUpload from 'components/Varios/InputFileUpload'
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';

//estilos
import "assets/scss/ModalAtenderCertificado/modal.scss";
import { classNameIconoFlechaRegresar } from 'constants/Icons-Font-Awesome';

type PropsModalAtenderCertificado = {
    show: boolean,
    onClose: () => void,
    toogle: () => void,
    datos: DatosVistaPrevia | undefined,
    handleCertificadoAtendido: () => void
}


export default function ModalAtenderCertificado(props: PropsModalAtenderCertificado) {

    const [fileCertificado, setfileCertificado] = useState<File | null>()
    const [loadingSubirCertificado, setloadingSubirCertificado] = useState<boolean>(false)
    const [mensajeError, setmensajeError] = useState<string>("")
    const [motivoNoAtendido, setmotivoNoAtendido] = useState<string>("")
    const [motivoFisico, setmotivoFisico] = useState<string>("")

    const [accionAtencion, setaccionAtencion] = useState<"noAtender" | "subirFisico" | "">("")

    const inputNoAtenderRef = useRef<HTMLInputElement>(null)

    const OPCIONES_SELECT_NOVEDAD: string[] = [
        "Observación del trámite no guarda relación con la solicitud realizada",
        "Solicitud realizada no aplica por no poseer relación laboral con ESPOL",
        "La Dirección de Talento Humano, no emite certificados de deudas de ESPOL",
        "El contrato con el cual realizó la solicitud, no está vigente. Ingrese nuevamente la solicitud"
    ];

    const OPCIONES_SELECT_MOTIVO_FISICO: string[] = [
        "Por solicitud expresa del usuario que lo desea con firma físca",
        "Porque la solicitud difiere de la necesidad de usuario expresada en las observaciones",
        "Por modificación del tipo de solicitud, a pedido del usuario"
    ];

    const RowFormModal: React.FC<{ sizecol: string, children: ReactNode }> = ({ sizecol, children }) => {
        return (
            <Row >
                <Col md={sizecol}>
                    {children}
                </Col>
            </Row>
        )

    }



    useEffect(() => {
        if (accionAtencion === "noAtender") {
            if (inputNoAtenderRef.current !== null) {
                inputNoAtenderRef.current.focus();
            }
            setmotivoNoAtendido(OPCIONES_SELECT_NOVEDAD[0]);
        }
        else if(accionAtencion === "subirFisico") {
            setmotivoFisico(OPCIONES_SELECT_MOTIVO_FISICO[0]);
        }
    }, [accionAtencion])


    function CerrarModal() {
        setfileCertificado(null);
        setloadingSubirCertificado(false)
        setmensajeError("")
        setmotivoNoAtendido("")
        setaccionAtencion("")
        document.body.classList.remove('modal-open')
        props.onClose();
    }


    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])

    const AtenderCertificado = useCallback(
        async (datos: DatosVistaPrevia | undefined) => {
            if (datos === undefined) {
                ;
            }
            setloadingSubirCertificado(true)
            var currentUser: UserData = authenticationService.currentUserValue;

            const formData = new FormData();
            if (fileCertificado && datos) {
                formData.append("Files", fileCertificado, fileCertificado.name);
                formData.append("IdSolicitudCertificado", datos.idsolicitud.toString());
                formData.append("concurrencyToken", datos.concurrencyToken?.toString() ?? "");
                formData.append("Motivo", motivoFisico);
            } else if (motivoNoAtendido !== "" && datos) {
                formData.append("IdSolicitudCertificado", datos.idsolicitud.toString());
                formData.append("concurrencyToken", datos.concurrencyToken?.toString() ?? "");
                formData.append("Motivo", motivoNoAtendido);

            }

            let instance = axios.create({ baseURL: configData.SERVER_URL });


            let options: AxiosRequestConfig = {
                url: `GenerarCertificados/AtenderCertificado`,
                data: formData,
                method: "PUT",
                headers: {
                    Authorization: `KEYESPOL ${currentUser?.token}`,
                    'Content-Type': 'multipart/form-data'
                }
            };
            try {
                const respuesta = await instance.request<any>(options)
                    .then((response) => {
                        if (response.status === 200) {
                            props.handleCertificadoAtendido();
                        }
                    })
                    .catch((error) => {
                        var mensaje_error: string = "Error desconocido. Intente más tarde";

                        if (axios.isAxiosError(error) && error.response) {
                            mensaje_error = error.response.data
                        } else {
                            mensaje_error = "No ha sido posible establecer contacto con el servidor."
                        }

                        setmensajeError(mensaje_error)
                    });

            } catch (error) {
                var mensaje_error: string = "Error desconocido. Intente más tarde";

                if (axios.isAxiosError(error) && error.response) {
                    mensaje_error = error.response.data
                } else {
                    mensaje_error = "No ha sido posible establecer contacto con el servidor."
                }

                setmensajeError(mensaje_error)
            }
            setloadingSubirCertificado(false)

        },
        [fileCertificado, motivoNoAtendido, motivoFisico],
    )


    function handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        setfileCertificado(fileInfo.file)
    }

    function ReiniciarContenido() {
        setaccionAtencion("")
        setfileCertificado(undefined)
        setmotivoNoAtendido("")
    }

    const HandleChangeMotivo = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            if (e.target.name === "motivoNoAtender") {
                setmotivoNoAtendido(e.target.value);
            } else if (e.target.name === "motivoFisico") {
                setmotivoFisico(e.target.value);
            }
        },
        [],
    )


    const ContenidoCuerpoModal = useMemo(() => {

        const BotonRegresar = (
            <Row form>
                <Col className="colContainerFlechaRegresar">
                    <Button onClick={() => ReiniciarContenido()}>
                        <i className={classNameIconoFlechaRegresar + " iconRegresarAtenderCertificado"}></i>
                    </Button>
                </Col>
            </Row>
        )

        if (mensajeError !== "") {
            return (
                <React.Fragment>
                    <Row form>
                        <Col md={12}>
                            <p className='small-error'>{mensajeError}</p>
                        </Col>
                    </Row>
                    <Row className={"justify-content-center"}>
                        <Col md={12}>
                            <Button onClick={() => CerrarModal()}>Cerrar</Button>
                        </Col>
                    </Row>

                </React.Fragment>
            )
        }
        else if (accionAtencion === "" && props.datos !== undefined) {
            return (
                <>
                    <div>
                        <label> Atender <span className='font-weight-bold'>{props.datos.nombreCertificado + " "}</span>  para {props.datos.nombrePersona}</label>
                    </div>
                    <Row form>
                        <Col md={6} className={"colModalAtenederCertificado"}>
                            <Button onClick={() => setaccionAtencion("noAtender")}>Responder</Button>
                        </Col>
                        <Col md={6} className={"colModalAtenederCertificado"}>
                            <Button onClick={() => setaccionAtencion("subirFisico")}>Subir físico</Button>
                        </Col>
                    </Row>
                </>

            )

        }
        else if (accionAtencion === "noAtender") {
            return (
                <React.Fragment>
                    {
                        loadingSubirCertificado && <Cargando mensaje='Atendiendo certificado' />
                    }
                    {
                        !loadingSubirCertificado && (
                            <React.Fragment>
                                {BotonRegresar}
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="motivoNoAtender"><strong>{"Escoja el motivo de la novedad que presenta la solicitud"}</strong></Label>

                                            {/* <Input maxLength={200}
                                                type="textarea"
                                                id="motivoNoAtender"
                                                value={motivoNoAtendido}
                                                innerRef={inputNoAtenderRef}
                                                onChange={(e) => HandleChangeMotivo(e)}
                                                cols={6}
                                                rows={5}
                                            /> */}

                                            <Input
                                                type="select"
                                                id="motivoNoAtender"
                                                name="motivoNoAtender"
                                                value={motivoNoAtendido}
                                                className="selectLargeText"
                                                onChange={(e) => HandleChangeMotivo(e)}
                                            >
                                                {
                                                    OPCIONES_SELECT_NOVEDAD.map((opcion, indiceOpcion) => {
                                                        return (
                                                            <option key={"opcionMotivoNoAtender" + indiceOpcion} value={opcion}>{opcion}</option>
                                                        )
                                                    })
                                                }


                                            </Input>

                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={12}>
                                        <Button disabled={motivoNoAtendido === ""} onClick={() => AtenderCertificado(props.datos)}  >Enviar</Button>
                                    </Col>
                                </Row>

                            </React.Fragment>)
                    }
                </React.Fragment>
            )
        }
        else if (accionAtencion === "subirFisico") {
            return (
                <>
                    {!loadingSubirCertificado &&
                        <React.Fragment>
                            {BotonRegresar}
                            <Row form>
                                <Col md={12}>

                                    <InputFileUpload
                                        icon="upload"
                                        onChange={handleFileUploadChange}
                                        name="SC"
                                        placeholder={"Subir Certificado Firmado Físicamente"}
                                        tooltipmessage={"Los archivos se subirán al momendo de dar clic en el botón Subir Certificado Físico"}


                                    />
                                </Col>

                            </Row>
                            <Row form className="mt-2">
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="motivoFisico"><strong>{"Escoja el motivo para entregar en físico"}</strong></Label>
                                        <Input
                                            type="select"
                                            id="motivoFisico"
                                            name="motivoFisico"
                                            value={motivoFisico}
                                            onChange={(e) => HandleChangeMotivo(e)}
                                            className="selectLargeText"
                                        >
                                            {
                                                OPCIONES_SELECT_MOTIVO_FISICO.map((opcion, indiceOpcion) => {
                                                    return (
                                                        <option key={"opcionMotivoFisico" + indiceOpcion} value={opcion}>{opcion}</option>
                                                    )
                                                })
                                            }
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {
                                fileCertificado && motivoFisico !== "" &&
                                <Row form>
                                    <Col>
                                        <Button
                                            onClick={() => AtenderCertificado(props.datos)}
                                        >
                                            Subir Certificado Físico
                                        </Button>
                                    </Col>
                                </Row>
                            }

                        </React.Fragment>
                    }
                    {
                        loadingSubirCertificado && <Cargando mensaje='Subiendo Certificado' />
                    }

                </>
            )
        }

    }, [accionAtencion, loadingSubirCertificado, motivoNoAtendido, motivoFisico, fileCertificado, mensajeError, props])


    return (
        <Modal
            isOpen={props.show}
            scrollable={false}
            size={"md "}
            fullscreen={"md"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={BotonCerrar}>
                Respuesta a la solicitud del certificado
            </ModalHeader>
            <ModalBody>
                {
                    <Container>

                        <Row>
                            <Col md={12}>
                                {ContenidoCuerpoModal}

                            </Col>
                        </Row>
                    </Container>
                }

            </ModalBody>

        </Modal>
    )
}
